import React from 'react';
import { Typography } from '@mui/material';
import { DropdownV2 } from '@warehouse/shared/ui';
import { FieldWrapper } from '../../ui/FieldWrapper';

export function ContentRelatedToPrimaryField({ primary, onPrimaryChange, onBlur }: ContentRelatedToPrimaryFieldProps) {
	const label = 'Primary';

	return (
		<FieldWrapper className="field-wrapper">
			<Typography variant="buttonMediumMedium" color="text.primary">
				{label}
			</Typography>
			<DropdownV2
				ariaLabel={label}
				value={primary}
				onBlur={onBlur}
				options={options}
				onChange={onPrimaryChange}
				disabledMargin
			/>
		</FieldWrapper>
	);
}

const options = [
	{
		value: true,
		label: 'True',
	},
	{
		value: false,
		label: 'False',
	},
];

export type ContentRelatedToPrimaryFieldProps = {
	primary: boolean;
	onPrimaryChange: (primary: boolean) => void;
	onBlur: () => void;
};
